import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { showSignUp, showForgetPassword } from '../../redux/actions';
import { renderErrorMessage } from '../../utils';
import Spinner from '../Spinner';
import { COLOR_GMAIL, COLOR_FACEBOOK } from '../../constants';
import Button from '../Button';
import { UNIT, PRIMARY, LINK } from '../../constants/configuration';

const INITIAL_STATE = {};

class ConnexionForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }

  renderInput = ({ input, type, placeholder, meta }) => {
    const className = `form-control ${meta.error && meta.touched ? 'is-invalid' : ''}`;
    return (
      <div className='form-group mb-0'>
        <input {...input} type={type} placeholder={placeholder} className={className} />
        <div className='invalid-feedback'>{meta.error}</div>
      </div>
    );
  };

  onSubmit = formValues => {
    const { onSubmit } = this.props;
    onSubmit(formValues.email, formValues.password);
  };

  facebookConnect = () => {
    const { facebookSignIn } = this.props;
    facebookSignIn();
  };

  googleConnect = () => {
    const { googleSignIn } = this.props;
    googleSignIn();
  };

  render() {
    const {
      handleSubmit,
      errorMessage,
      loadingConnexion,
      showSignUp,
      showForgetPassword,
      facebook,
      google,
      secondaryColor
    } = this.props;
    const { auth } = google;
    return (
      <>
        <form onSubmit={handleSubmit(this.onSubmit)}>
          {errorMessage !== '' && <p className='text-danger'>{renderErrorMessage(errorMessage)}</p>}
          <Field
            name='email'
            type='email'
            placeholder='email@gmail.com'
            component={this.renderInput}
          />
          <div className='mb-3' />
          <Field
            name='password'
            type='password'
            placeholder='*****************'
            component={this.renderInput}
          />
          {loadingConnexion && (
            <div className='mt-4'>
              <Spinner />
            </div>
          )}
          {!loadingConnexion && (
            <div className='text-right'>
              <Button
                type={LINK}
                className='p-0'
                style={{ fontSize: UNIT * 0.875 }}
                onClick={() => {
                  showForgetPassword(true);
                }}
              >
                Mot de passe oublié ?
              </Button>
            </div>
          )}
          {!loadingConnexion && (
            <Button type={PRIMARY} isSubmit className='btn-block mt-3'>
              Connexion
            </Button>
          )}
        </form>
        {!loadingConnexion && facebook.auth && (
          <Button
            className='text-white btn-block mt-2'
            style={{ backgroundColor: COLOR_FACEBOOK, borderColor: COLOR_FACEBOOK }}
            onClick={this.facebookConnect}
          >
            <div className='text-center'> Se connecter avec Facebook</div>
          </Button>
        )}
        {!loadingConnexion && auth && (
          <Button
            className='text-white btn-block mt-2'
            onClick={this.googleConnect}
            style={{ backgroundColor: COLOR_GMAIL, borderColor: COLOR_GMAIL }}
          >
            <div className='text-center'> Se connecter avec Google</div>
          </Button>
        )}
        {!loadingConnexion && (
          <div className='row justify-content-center align-items-center mt-5'>
            <span className='align-baseline'>Vous n'avez pas de compte?</span>
            <Button
              type={LINK}
              onClick={() => {
                showSignUp(true);
              }}
              style={{ color: secondaryColor }}
            >
              Inscrivez-vous
            </Button>
          </div>
        )}
      </>
    );
  }
}

const validate = formValues => {
  const errors = {};
  if (!formValues.email) {
    errors.email = 'Merci de fournir un mail';
  }

  if (!formValues.password) {
    errors.password = 'Merci de fournir un mot de passe';
  }

  return errors;
};

const mapStateToProps = ({ configurationReducer, userReducer }) => {
  const { loadingConnexion } = userReducer;
  const { secondaryColor, facebook, google } = configurationReducer;
  return { secondaryColor, loadingConnexion, facebook, google };
};

ConnexionForm = connect(mapStateToProps, { showSignUp, showForgetPassword })(ConnexionForm);

export default reduxForm({
  form: 'connexionForm',
  validate
})(ConnexionForm);
